import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OidcSecurityService } from 'angular-auth-oidc-client';

export interface UserClaims {
  [key: string]: string;
}

@Injectable()
export class AppUserInfoFacade {
  userAuthd$: Observable<boolean>;
  userClaims$: Observable<UserClaims>;

  constructor(private readonly oidcSecurityService: OidcSecurityService) {
    this.userAuthd$ = this.isAuthorized();
    this.userClaims$ = this.loadUserInfo();
  }
  /**
   * Show display when a user is authorized
   */
  isAuthorized() {
    return this.oidcSecurityService.isAuthenticated();
  }
  /**
   * Load user info to display names
   */
  loadUserInfo(): Observable<UserClaims> {
    const CustomerNameKey =
      'http://schemas.satcomdirect.com/ws/2014/10/identity/claims/customername';
    return this.oidcSecurityService.getUserData().pipe(
      map((userClaims: UserClaims) => {
        if (userClaims) {
          userClaims = Object.assign({}, userClaims);
          const keys = Object.keys(userClaims);
          const values = Object.values(userClaims);
          if (userClaims && values[keys.indexOf(CustomerNameKey)]) {
            userClaims.customerName = values[keys.indexOf(CustomerNameKey)];
          }
        }
        return userClaims;
      })
    );
  }

  currentUserId(): Observable<string> {
    return this.userClaims$.pipe(map(claims => claims.sub));
  }
}
